module.exports = __webpack_public_path__ + "img/1559402234.411e89c0.jpg";